import React, { useCallback } from 'react';
import { CheckIcon } from '@prisjakt/ui-icons';
import { ListFilterItem } from '../../types';
import * as S from './styles';

type CheckboxProps = {
  item: ListFilterItem;
  selected: boolean;
  onClick: (id: string) => void;
};

const Checkbox = ({ item, selected, onClick }: CheckboxProps) => {
  const { id, value, count, path, indexable } = item;
  const onClickItem = useCallback(
    e => {
      e.preventDefault();

      onClick(id);
    },
    [onClick, id]
  );

  return (
    <S.OptionListItem key={id}>
      <S.Option to={(indexable && path) || undefined} onClick={onClickItem}>
        <S.Checkbox checked={selected}>
          <CheckIcon
            styling="neutral-light"
            strokeWidth="6"
            height={14}
            left={1}
            top={1}
            checked={selected}
          />
        </S.Checkbox>
        <S.Name>{value}</S.Name>
        {count !== undefined && <S.Count>{count}</S.Count>}
      </S.Option>
    </S.OptionListItem>
  );
};

type Props = {
  items: ListFilterItem[];
  getSelectedState: (id: string) => boolean;
  onClickItem: (id: string) => void;
};

const Checkboxes = ({ items, getSelectedState, onClickItem }: Props) => {
  return (
    <>
      {items.map(item => (
        <Checkbox
          key={item.id}
          item={item}
          selected={getSelectedState(item.id)}
          onClick={onClickItem}
        />
      ))}
    </>
  );
};

export default Checkboxes;
